import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-plum-50 py-16 md:py-20" data-id="element-17" data-mp="av37exjcfd39">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-18" data-mp="aujy257rdx0u">
        <SectionHeading eyebrow="Los 3 bonos" title={<>
              Pero el sistema <span className="italic text-gold-700" data-id="element-20" data-mp="1tc1brkw548v">no termina ahí…</span>
            </>} intro={<p data-id="element-21" data-mp="5wrwejhbawjg">3 bonos que amplían el acompañamiento, incluidos hoy sin costo adicional.</p>} data-id="element-19" data-mp="ftegv75q7lky" />

        <ul className="mt-12 grid gap-6 lg:grid-cols-3" data-id="element-22" data-mp="3o2wsxj8lq7nr">
          {bonuses.map(bonus => <li key={bonus.tag} className="flex h-full flex-col overflow-hidden rounded-xl bg-white shadow-card" data-id="element-23" data-mp="3t1rcwoib229g">
              <div className="h-1 w-full bg-gold-500" aria-hidden="true" data-id="element-24" data-mp="1r9berkvjlfub" />
              <div className="flex flex-1 flex-col p-6 md:p-7" data-id="element-25" data-mp="1r78snbxig6uv">
                <header className="text-center" data-id="element-26" data-mp="3ideni9vmma6z">
                  <p className="text-[0.7rem] font-bold uppercase tracking-[0.18em] text-gold-700" data-id="element-27" data-mp="3ic3kica096gx">
                    {bonus.tag}
                  </p>
                  <h3 className="mt-3 font-display text-xl font-extrabold leading-tight text-plum-700 md:text-[1.55rem]" data-id="element-28" data-mp="3r5gjnvynx4bg">
                    {bonus.title}
                  </h3>
                  <p className="mt-2.5 text-[0.95rem] text-muted" data-id="element-29" data-mp="2zesk2ocn06zw">{bonus.subtitle}</p>
                </header>

                <p className="mt-5 border-t border-plum-100 pt-5 leading-relaxed text-ink" data-id="element-30" data-mp="2uhiw7d4wc3e6">
                  {bonus.description}
                </p>

                {bonus.items && <div className="mt-4" data-id="element-31" data-mp="33gw6u94ray0h">
                    {bonus.itemsLabel && <p className="mb-2.5 font-semibold text-plum-700" data-id="element-32" data-mp="npi3scdwrwsn">{bonus.itemsLabel}</p>}
                    <ul className="space-y-2" data-id="element-33" data-mp="irq4gxaxp8ef">
                      {bonus.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-34" data-mp="3chv39kmwh2k0">
                          <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-teal-500" aria-hidden="true" data-id="element-35" data-mp="3hhrbjw2mrg5d" />
                          <span className="text-[0.95rem] text-ink" data-id="element-36" data-mp="3qiphijwmpxql">{item}</span>
                        </li>)}
                    </ul>
                  </div>}

                <p className="mt-auto pt-7 text-center" data-id="element-37" data-mp="2xu0bq7kmp48i">
                  <span className="inline-flex rounded-full bg-gold-500 px-4 py-1.5 text-[0.65rem] font-bold uppercase tracking-[0.14em] text-ink" data-id="element-38" data-mp="2xujqjfezfcib">
                    {bonus.badge}
                  </span>
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}